import { render, staticRenderFns } from "./BillAppointmentsListItem.vue?vue&type=template&id=48245fb8&scoped=true"
import script from "./BillAppointmentsListItem.vue?vue&type=script&lang=js"
export * from "./BillAppointmentsListItem.vue?vue&type=script&lang=js"
import style0 from "./BillAppointmentsListItem.vue?vue&type=style&index=0&id=48245fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48245fb8",
  null
  
)

export default component.exports